type IconProps = { size?: number; color?: string; className?: string };

export function ChatIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M4 5h16v11H10l-5 4v-4H4z" stroke={color} strokeWidth="2.2" strokeLinejoin="round" />
      <path
        d="M12 8l0.9 2.1L15 11l-2.1 0.9L12 14l-0.9-2.1L9 11l2.1-0.9z"
        fill={color}
        stroke={color}
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
      <path d="M3 13l6 6L21 5" fill="none" stroke={color} strokeWidth="3.5" />
    </svg>
  );
}

export function PlayIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
      <path d="M8 5.5v13l11-6.5z" fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

export function PauseIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
      <rect x="6" y="5" width="4.4" height="14" rx="1" fill={color} />
      <rect x="13.6" y="5" width="4.4" height="14" rx="1" fill={color} />
    </svg>
  );
}

export function LockIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <rect x="5" y="10.5" width="14" height="9" rx="1.5" stroke={color} strokeWidth="2.2" />
      <path d="M8 10.5V8a4 4 0 018 0v2.5" stroke={color} strokeWidth="2.2" />
      <circle cx="12" cy="15" r="1.6" fill={color} />
    </svg>
  );
}

export function FileIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M6 3h8l4 4v14H6z" stroke={color} strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M14 3v4h4" stroke={color} strokeWidth="2.2" strokeLinejoin="round" />
    </svg>
  );
}

export function MicIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <rect x="9" y="3" width="6" height="11" rx="3" stroke={color} strokeWidth="2.2" />
      <path d="M5.5 11.5a6.5 6.5 0 0013 0M12 18v3" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export function ChevronRightIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M9 5l7 7-7 7" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ChevronLeftIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M15 5l-7 7 7 7" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function WaveIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M4 10v4M8 7v10M12 4v16M16 7v10M20 10v4"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CopyIcon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <rect x="9" y="9" width="11" height="11" rx="2" stroke={color} strokeWidth="2" />
      <path d="M5 15H4.5A1.5 1.5 0 013 13.5v-9A1.5 1.5 0 014.5 3h9A1.5 1.5 0 0115 4.5V5" stroke={color} strokeWidth="2" />
    </svg>
  );
}

export function SkipBack10Icon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M12 4.5a7.5 7.5 0 11-6.7 4.1" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M5 4v4.8h4.8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <text x="12.1" y="15.4" textAnchor="middle" fontSize="7.4" fontWeight="700" fill={color} stroke="none" fontFamily="inherit">
        10
      </text>
    </svg>
  );
}

export function SkipFwd10Icon({ size = 24, color = 'currentColor', className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path d="M12 4.5a7.5 7.5 0 106.7 4.1" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M19 4v4.8h-4.8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <text x="12.1" y="15.4" textAnchor="middle" fontSize="7.4" fontWeight="700" fill={color} stroke="none" fontFamily="inherit">
        10
      </text>
    </svg>
  );
}
